import { useContext, useState } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import LogicGroupsDivider from '../common/LogicGroupsDivider';
import { Text } from 'foundations-components/components/Text';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import FiltersDisplay from '../filtersDisplay/FiltersDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickFilters = () => {
  const [isVisible, setIsVisible] = useState(true);
  const {
    props: {
      baseFilterFamily,
      quickFilters,
      uiMessages: {
        quickFiltersDescription
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  if (!quickFilters) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: "400",
    paddingBlockStart: "400",
    as: "div",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFilters.title"
        })
      }), isVisible ? /*#__PURE__*/_jsx(Button, {
        onClick: () => setIsVisible(false),
        use: "link",
        responsive: false,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFilters.toggleButtonClose"
        })
      }) : /*#__PURE__*/_jsx(Button, {
        onClick: () => setIsVisible(true),
        use: "link",
        responsive: false,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFilters.toggleButtonOpen"
        })
      })]
    }), isVisible && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: quickFiltersDescription || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFilters.description"
        })
      }), /*#__PURE__*/_jsx(FiltersDisplay, {
        baseFilterFamily: baseFilterFamily,
        value: quickFilters
      })]
    }), /*#__PURE__*/_jsx(LogicGroupsDivider, {
      logicOperator: LogicGroupNames.AND,
      paddingBlockEnd: "0"
    })]
  });
};
export default QuickFilters;